export default __webpack_public_path__ + "static/media/header-back.41547b20.jpg";